<p-dialog [(visible)]="visible" [draggable]="false" [modal]="true" appendTo="body"
    [style]="{ 'max-width': '90vw', 'min-width': '70vw' }">
    <ng-template pTemplate="header">
        <div class="flex justify-start items-start flex-col">
            <h1 class="text-xl"><b>Añadir video</b></h1>
            <small class="mb-4 italic opacity-80"><b>Aquí podrá agregar la URL del video. El mismo se va a insertar en
                    el editor, como un frame embebido.</b></small>
        </div>
    </ng-template>

    <c-input #input placeholder="Ingrese la url del video" etiqueta="URL" />

    <ng-template pTemplate="footer">
        <div class="flex justify-end">
            <petrol-button variant="tertiary" (click)="close(input.valor())">Cerrar</petrol-button>
        </div>
    </ng-template>
</p-dialog>